import React, { Component } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import { fetchClients } from '../../../store/actions/clients/clientsActions';
import { clientProjects, groupClientProjects } from '../../../store/actions/projects/projectsActions';
import { refreshReports, mergeBudgetRevenueDetails, mergeActualRevenueDetails } from '../../../store/actions/reports/reportsActions';
import { clearApprovedTimeEntries } from '../../../store/actions/timesheet/timesheetActions';
import { PROFIT_NET_OF_TAX_MULTIPLIER } from '../../../store/actions/projects/projectCostingActions';

import PageTitle from '../../../common/PageTitle';

import ProjectDetailsRow from './ProjectDetailsRow';
import BudgetTable from './BudgetTable';
import ActualTable from './ActualTable';
import VarianceTable from './VarianceTable';
import ExportReport from '../ExportReport';

class ProfitibilityPerClient extends Component {

  constructor(props) {
    super(props);
    this.showTable = false; 
    this.projectId = 0;
    this.startDate = new Date(moment().subtract(1, 'weeks').startOf('isoWeek'));
    this.endDate = new Date(moment().subtract(1, 'weeks').endOf('isoWeek'));
    this.startMaxDate = this.startDate;
    this.endMinDate = this.endDate;

    this.clientProjectRows = [];
  }
  
  componentDidMount() {
    this.props.fetchClients();
  }
  
  displayClientDropdown = () => {
    let clientOptions = [];

    let clients = this.props.clients.clients;

    clientOptions = clients.length && clients.map(client => {
      return {
        label: client.client_name, 
        value: client.id
      }
    })

    const selectClass = 'projectSelect';

    return (
        <Select
          className={selectClass}
          classNamePrefix={selectClass}
          size="sm"
          onChange={(selectedOption) => {
            this.clientId = selectedOption.value;
            this.clientName = selectedOption.label;
          }}
          options={clientOptions}
        />
    )
  }

  displayDatepicker = () => {
    return (
      <Row>
        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
          <DatePicker
            placeholderText="Start Date"
            minDate={this.minDate}
            maxDate={this.maxDate}
            onChange={(date) => {
              this.startDate = date;
              this.endMinDate = date;
              this.props.refreshReports();
            }} 
            selected={this.startDate}
            
          /> 
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
          <DatePicker
            placeholderText="End Date"
            minDate={this.minDate}
            onChange={(date) => {
              this.endDate = date;
              this.startMaxDate = date;
              this.props.refreshReports();
            }} 
            selected={this.endDate}
          /> 
        </Col>
      </Row>
    )
  }

  displayGenerateButton = () => {
    return (
      <Button
        id={this.buttonId}
        onClick={()=>{
          this.showTable = true;
          this.props.clearApprovedTimeEntries();
          this.props.clientProjects(this.clientId, true, this.startDate, this.endDate);
        }}
      >
        Generate Report
      </Button>
    )
  }

  generateBudgetDetails = () => {
    if (!this.showTable) {
      return ''
    }

    let projectCards = [];

    let clientProjects = groupClientProjects(this.props.projects.clientProjects);

    let totalMandays = 0;
    let totalRevenue = 0;
    let totalFullyLoadedCost = 0;
    let totalUnloadedCost = 0;
    let totalExternalCost = 0;
    let totalTotalCost = 0;
    let totalProfitNetofTax = 0;
    let totalProfitBeforeTax = 0;

    this.budgetScopeRows = []

    projectCards = clientProjects.length ? clientProjects.map((project, key) => { 
      let budgetScope = {
        mandays: 0, 
        revenue: 0,
        fullyLoadedCost: 0,
        unloadedCost: 0, 
        externalCost: 0,
        projectId: 0,
        projectName: ''
      }

      let arrProject = [];
      let projectId = 0;
      let projectName = '';
    
      //if a sole project, transform to array
      if (!Array.isArray(project)) {
        projectId = project.id;
        projectName = project.project_name;
        arrProject.push(project);
      }
      else {

        //get parent project name
        project.forEach(proj => {
          if (!proj.parent_parent) {
            projectId = proj.id;
            projectName = proj.project_name;
          }
        })
        arrProject = project;
      }

      let result = mergeBudgetRevenueDetails(arrProject);
     
      if (result) {
        budgetScope.projectName = projectName; 
        budgetScope.projectId = projectId;
        budgetScope.mandays = +result.totalMandays;
        budgetScope.revenue = +result.totalRevenue;
        budgetScope.fullyLoadedCost = +result.totalFullyLoadedCost;
        budgetScope.unloadedCost = +result.totalUnloadedCost;
        budgetScope.externalCost = +result.totalExternalCost;
        budgetScope.totalCost = +result.totalFullyLoadedCost + +result.totalUnloadedCost + +result.totalExternalCost;
        budgetScope.profitBeforeTax = +budgetScope.revenue - +budgetScope.totalCost;
        budgetScope.profitNetofTax = +budgetScope.profitBeforeTax * PROFIT_NET_OF_TAX_MULTIPLIER;

        this.budgetScopeRows.push(budgetScope);

        totalMandays += +result.totalMandays;
        totalRevenue += +result.totalRevenue;
        totalFullyLoadedCost += +result.totalFullyLoadedCost;
        totalUnloadedCost += +result.totalUnloadedCost;
        totalExternalCost += result.totalExternalCost;
        totalTotalCost += +budgetScope.totalCost;
        totalProfitBeforeTax += +budgetScope.profitBeforeTax;
        totalProfitNetofTax += +budgetScope.profitNetofTax;
      }
      
      return (
        <ProjectDetailsRow 
          key={key} 
          projectId={projectId} 
          projectName={projectName} 
          rowDetails={budgetScope} 
          addProjectName={true} />
      )
    }) : []

    let budgetDetailsTotals = {}

    budgetDetailsTotals.totalMandays = totalMandays;
    budgetDetailsTotals.totalRevenue = totalRevenue;
    budgetDetailsTotals.totalFullyLoadedCost = totalFullyLoadedCost;
    budgetDetailsTotals.totalUnloadedCost = totalUnloadedCost;
    budgetDetailsTotals.totalExternalCost = totalExternalCost;
    budgetDetailsTotals.totalTotalCost = totalTotalCost;
    budgetDetailsTotals.totalProfitBeforeTax = totalProfitBeforeTax;
    budgetDetailsTotals.totalProfitNetofTax = totalProfitNetofTax;

    this.budgetDetailsTotals = budgetDetailsTotals;

    return projectCards;
  }

  generateActualDetails = () => {
    if (!this.showTable) {
      return ''
    }

    let projectRows = [];

    let clientProjects = groupClientProjects(this.props.projects.clientProjects);

    let totalMandays = 0;
    let totalRevenue = 0;
    let totalFullyLoadedCost = 0;
    let totalUnloadedCost = 0;
    let totalExternalCost = 0;
    let totalTotalCost = 0;
    let totalProfitNetofTax = 0;
    let totalProfitBeforeTax = 0;

    this.actualChargesRows = [];

    projectRows = clientProjects.length ? clientProjects.map((project, key) => { 

      let arrProject = [];
      let projectId = 0;
      let projectName = '';

      //if a sole project, transform to array
      if (!Array.isArray(project)) {
        projectId = project.id;
        projectName = project.project_name;
        arrProject.push(project)
      }
      else {

        //get parent project name
        project.forEach(proj => {
          if (!proj.parent_parent) {
            projectId = proj.id;
            projectName = proj.project_name;
          }
        })
        arrProject = project;
      }

      const timeEntries = this.props.timesheets.approvedTimeEntries || [];

      let result = mergeActualRevenueDetails(arrProject, timeEntries);

      let actualCharges = {}
      
      if (result) {
        actualCharges.projectId = projectId;
        actualCharges.mandays = +result.totalMandays;
        actualCharges.revenue = +result.totalRevenue;
        actualCharges.fullyLoadedCost = +result.totalFullyLoadedCost;
        actualCharges.unloadedCost = +result.totalUnloadedCost;
        actualCharges.externalCost = +result.totalExternalCost;
        actualCharges.totalCost = +result.totalFullyLoadedCost + +result.totalUnloadedCost + +result.totalExternalCost;
        actualCharges.profitBeforeTax = +actualCharges.revenue - +actualCharges.totalCost;
        actualCharges.profitNetofTax = +actualCharges.profitBeforeTax * PROFIT_NET_OF_TAX_MULTIPLIER;

        this.actualChargesRows.push(actualCharges);

        totalMandays += +result.totalMandays;
        totalRevenue += +result.totalRevenue;
        totalFullyLoadedCost += +result.totalFullyLoadedCost;
        totalUnloadedCost += +result.totalUnloadedCost;
        totalExternalCost += result.totalExternalCost;
        totalTotalCost += +actualCharges.totalCost;
        totalProfitBeforeTax += +actualCharges.profitBeforeTax;
        totalProfitNetofTax += +actualCharges.profitNetofTax;
      }
      return (
        <ProjectDetailsRow key={key} 
          projectId={projectId} 
          projectName={projectName} 
          rowDetails={actualCharges} 
          addProjectName={false} />
      )
    }) : []

    let actualDetailsTotals = {}

    actualDetailsTotals.totalMandays = totalMandays;
    actualDetailsTotals.totalRevenue = totalRevenue;
    actualDetailsTotals.totalFullyLoadedCost = totalFullyLoadedCost;
    actualDetailsTotals.totalUnloadedCost = totalUnloadedCost;
    actualDetailsTotals.totalExternalCost = totalExternalCost;
    actualDetailsTotals.totalTotalCost = totalTotalCost;
    actualDetailsTotals.totalProfitBeforeTax = totalProfitBeforeTax;
    actualDetailsTotals.totalProfitNetofTax = totalProfitNetofTax;

    this.actualDetailsTotals = actualDetailsTotals;

    return projectRows;

  }

  generateVarianceDetails = () => {
    let varianceRows = [];

    let totalMandays = 0;
    let totalRevenue = 0;
    let totalFullyLoadedCost = 0;
    let totalUnloadedCost = 0;
    let totalExternalCost = 0;
    let totalTotalCost = 0;
    let totalProfitNetofTax = 0;
    let totalProfitBeforeTax = 0;

    varianceRows = this.budgetScopeRows.map((budgetScopeRow, key) => {

      let mandays = 0;
      let revenue = 0;
      let fullyLoadedCost = 0;
      let unloadedCost = 0;
      let totalCost = 0;
      let profitBeforeTax = 0;
      let profitNetofTax = 0;

      let projectId = budgetScopeRow.projectId;
      let projectName = budgetScopeRow.projectName;
      let externalCost = +budgetScopeRow.externalCost;

      this.actualChargesRows.filter(data => { 
        if (data.projectId === projectId) {
          return data;
        }
        return false;
      }).forEach((actualChargesRow) => {

        console.log('budgetScopeRow', budgetScopeRow);
        console.log('actualChargesRow', actualChargesRow);

        revenue = +budgetScopeRow.revenue - +actualChargesRow.revenue;
        mandays = +budgetScopeRow.mandays - +actualChargesRow.mandays;
        fullyLoadedCost = +budgetScopeRow.fullyLoadedCost - +actualChargesRow.fullyLoadedCost;
        unloadedCost = +budgetScopeRow.unloadedCost - +actualChargesRow.unloadedCost;
        totalCost = +budgetScopeRow.totalCost - +actualChargesRow.totalCost
        profitBeforeTax = +actualChargesRow.profitBeforeTax - +budgetScopeRow.profitBeforeTax;
        profitNetofTax = +actualChargesRow.profitNetofTax - +budgetScopeRow.profitNetofTax;
      })

      totalMandays += +mandays;
      totalRevenue += +revenue;
      totalFullyLoadedCost += +fullyLoadedCost;
      totalUnloadedCost += +unloadedCost;
      totalExternalCost += +externalCost;
      totalTotalCost += +totalCost;
      totalProfitBeforeTax += +profitBeforeTax;
      totalProfitNetofTax += +profitNetofTax;
      
      let varianceDetails = {
        mandays, 
        revenue, 
        fullyLoadedCost, 
        unloadedCost, 
        externalCost,
        totalCost,
        profitBeforeTax, 
        profitNetofTax
      }

      return (
        <ProjectDetailsRow projectId={projectId} projectName={projectName} rowDetails={varianceDetails} key={key} />
      )
    })

    let varianceDetailsTotals = {}

    varianceDetailsTotals.totalMandays = totalMandays;
    varianceDetailsTotals.totalRevenue = totalRevenue;
    varianceDetailsTotals.totalFullyLoadedCost = totalFullyLoadedCost;
    varianceDetailsTotals.totalUnloadedCost = totalUnloadedCost;
    varianceDetailsTotals.totalExternalCost = totalExternalCost;
    varianceDetailsTotals.totalTotalCost = totalTotalCost;
    varianceDetailsTotals.totalProfitBeforeTax = totalProfitBeforeTax;
    varianceDetailsTotals.totalProfitNetofTax = totalProfitNetofTax;

    this.varianceDetailsTotals = varianceDetailsTotals;

    return varianceRows;
  }

  renderTables = () => {

    let clientProjects = this.props.projects.clientProjects;

    if (!this.showTable) {
      return '';
    }

    if (!clientProjects) {
      return (
        <div className="mt-5">No projects found.</div>
      )
    }

    if (!clientProjects.length) {
      return (
        <div className="mt-5">Loading...</div>
      )
    }
    else {
      clientProjects = groupClientProjects(clientProjects);

      let projectBudgetDetails = this.generateBudgetDetails();
      let projectActualDetails = this.generateActualDetails();
      let projectVarianceDetails = this.generateVarianceDetails();
      return (
        <>
          <Row className="mt-5">
            <Col xs={12} sm={12} md={12} lg={12} xl={12}><b>Client Name: </b> {this.clientName}</Col>
          </Row>
          <div>
            <Row className="report-display">
              <Col xs={12} sm={12} md={12} lg={12} xl={12} className='col-profit'>
              <b>BUDGET</b>
                <BudgetTable projectBudgetDetails={projectBudgetDetails} budgetDetailsTotals={this.budgetDetailsTotals} />
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} className='col-profit'>
              <b>ACTUAL</b>
                <ActualTable projectActualDetails={projectActualDetails} actualDetailsTotals={this.actualDetailsTotals} />
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} className='col-profit'>
              <b>VARIANCE</b>
                <VarianceTable projectVarianceDetails={projectVarianceDetails} varianceDetailsTotals={this.varianceDetailsTotals} />
              </Col>
            </Row>
          </div>
        </>
      )
    }
  }

  renderExportFile = () => {

    const clientProjects = this.props.projects.clientProjects;

    if (!this.showTable || !clientProjects) {
      return '';
    }

    this.exportReportHeader = [
      ['Profitability Analysis'], 
      ['Client Name', this.clientName],
      [],
      []
    ];

    if (clientProjects.length) {
      
      const budgetTotals = Array.from(document.querySelectorAll('.totals-budget'));
      const actualTotals = Array.from(document.querySelectorAll('.totals-actual'));
      const varianceTotals = Array.from(document.querySelectorAll('.totals-variance'));
      
      let projectRevenueDetails = [];

      clientProjects.forEach(project => {
        let arrDetails = [];
        const projectName = project.project_name;
        const mandays = Array.from(document.querySelectorAll('.row-mandays-' + project.id));
        const revenue = Array.from(document.querySelectorAll('.row-revenue-' + project.id));
        const fullyLoadedCost = Array.from(document.querySelectorAll('.row-fully-loaded-cost-' + project.id));
        const unloadedCost = Array.from(document.querySelectorAll('.row-unloaded-cost-' + project.id));
        const externalCost = Array.from(document.querySelectorAll('.row-external-cost-' + project.id));
        const totalCost = Array.from(document.querySelectorAll('.row-total-cost-' + project.id));
        const profitBeforeTax = Array.from(document.querySelectorAll('.row-profit-before-tax-' + project.id));
        const profitNetofTax = Array.from(document.querySelectorAll('.row-profit-net-after-tax-' + project.id));

        if (mandays.length && 
          revenue.length && 
          fullyLoadedCost.length && 
          unloadedCost.length && 
          externalCost.length && 
          totalCost.length && 
          profitBeforeTax.length && 
          profitBeforeTax.length) {
            arrDetails.push(
              projectName, 
              mandays, 
              revenue, 
              fullyLoadedCost,
              unloadedCost,
              externalCost, 
              totalCost, 
              profitBeforeTax,
              profitNetofTax
            )
   
            projectRevenueDetails.push(arrDetails);
        }
      })
      let rows = [];

      projectRevenueDetails.length && projectRevenueDetails.forEach(details => {
        
        let row = [details[0]];

        for (let t = 0; t < 3; t++) {
          let mandays = details[1][t].innerHTML;
          let revenue = details[2][t].innerHTML;
          let fullyLoadedCost = details[3][t].innerHTML;
          let unloadedCost = details[4][t].innerHTML;
          let externalCost = details[5][t].innerHTML;
          let totalCost = details[6][t].innerHTML;
          let profitBeforeTax = details[7][t].innerHTML;
          let profitNetofTax = details[8][t].innerHTML;

          row.push(mandays);
          row.push(revenue);
          row.push(fullyLoadedCost);
          row.push(unloadedCost);
          row.push(externalCost);
          row.push(totalCost);
          row.push(profitBeforeTax);
          row.push(profitNetofTax);

          row.push('', '');
        }

        rows.push(row);
      })

      let totals = ['Totals'];

      budgetTotals.length && budgetTotals.forEach(total => {
        totals.push(total.innerHTML);
      })

      totals.push('', '');

      actualTotals.length && actualTotals.forEach(total => {
        totals.push(total.innerHTML);
      })

      totals.push('', '');

      varianceTotals.length && varianceTotals.forEach(total => {
        totals.push(total.innerHTML);
      })

      rows.push(totals);

      this.clientProjectRows = rows;
    }
  }

  generateExportButton = () => {
    const clientProjects = this.props.projects.clientProjects;

    if (!this.showTable || (!clientProjects)) {
      return '';
    }

    if (!clientProjects.length) {
      return '';
    }

    let data = this.exportReportHeader;

    data.push(
      [
        '', '', '', '', '', 'BUDGET', 
        '', '', '', '', '', '', '', '', '', 'ACTUAL', 
        '', '', '', '', '', '', '', '', '', 'VARIANCE'
      ]
    )

    let tableHeaders = [];

    const tableHeaderNames = ['Total Mandays', 
    'Revenue', 
    'Fully Loaded Cost', 
    'Unloaded Cost', 
    'Other Cost', 
    'Total Cost',
    'Profit before Tax', 
    'Profit after Tax'];

    tableHeaders.push('Project', ...tableHeaderNames, '', '', ...tableHeaderNames, '', '', ...tableHeaderNames);

    data.push(tableHeaders);

    this.clientProjectRows.length && this.clientProjectRows.forEach(row => {
      data.push(row);
    })

    return (
      <ExportReport data={data} fileName="profitability_per_client" />
    )
  }

  render() {
    this.renderExportFile();
    return (
      <>
        <PageTitle pageName="Profitability per Client" />
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Row>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                { this.displayClientDropdown() }
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                { this.displayDatepicker() }
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                { this.displayGenerateButton() }
              </Col>
            </Row>
          </Col>
        </Row>
        { this.renderTables() }
        <Row className="mt-5">
          <Col>
            { this.generateExportButton() }
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => ({ 
  clients: state.clients,
  reports: state.reports, 
  projects: state.projects,
  timesheets: state.timesheets 
})

const mapDispatchToProps = (dispatch) => ({
  fetchClients: (...args) => dispatch(fetchClients(...args)),
  clientProjects: (...args) => dispatch(clientProjects(...args)),
  clearApprovedTimeEntries: () => dispatch(clearApprovedTimeEntries()), 
  refreshReports: () => dispatch(refreshReports()),
}) 


export default connect(mapStateToProps, mapDispatchToProps)(ProfitibilityPerClient)